import { fetch, getIdOrNull } from '..'
import { HttpMethods, makeQueryString } from '../apiHelper'
import { OrderDirections } from '../constants'
import apiClient from './apiClient'

export const sendInternshipMessage = (user, { internship, content }) => {
  return fetch(
    '/internship-message/send',
    HttpMethods.POST,
    { internship, content },
    user
  )
}
export const sendMaccsInternshipMessage = (user, { maccsInternship, content }) => apiClient.post(user, 'maccs-internship-message/send', { maccsInternship, content })

const DEFAULT_PARAM_GET_MESSAGES = { page: 1, pageSize: 50, unread: false, orderDirection: OrderDirections.DESC }
export const getInternshipsMessages = (user, currentUser, params = DEFAULT_PARAM_GET_MESSAGES) => {
  return fetch(
    `/api/users/${getIdOrNull(currentUser)}/internship-messages${makeQueryString(params)}`,
    HttpMethods.GET,
    null,
    user
  )
}
export const getMaccsInternshipsMessages = (user, currentUser, params = DEFAULT_PARAM_GET_MESSAGES) => apiClient.get(user, `api/users/${getIdOrNull(currentUser)}/maccs-internship-messages${makeQueryString(params)}`)

export const getInternshipMessages = (user, internship) => {
  return fetch(
    `/internship-message/consult/${getIdOrNull(internship)}`,
    HttpMethods.GET,
    null,
    user
  )
}
export const getMaccsInternshipMessages = (user, internship) => apiClient.get(user, `maccs-internship-message/consult/${getIdOrNull(internship)}`)

export const readInternshipMessages = (user, internship) => {
  return fetch(
    '/internship-message/read',
    HttpMethods.POST,
    { internship: getIdOrNull(internship) },
    user
  )
}
export const readMaccsInternshipMessages = (user, internship) => apiClient.post(user, 'maccs-internship-message/read', { maccsInternship: getIdOrNull(internship) })

export const unreadInternshipMessage = (user, messageId) => {
  return fetch(
    '/internship-message/unread',
    HttpMethods.POST,
    { messageId },
    user
  )
}
export const unreadMaccsInternshipMessage = (user, messageId) => apiClient.post(user, 'maccs-internship-message/unread', { messageId })

export const getInternshipsMessagesCount = (user, params = { ids: [] }) => {
  return fetch(
    `/internships/internship-messages${makeQueryString(params)}`,
    HttpMethods.GET,
    null,
    user
  )
}
export const getMaccsInternshipsMessagesCount = (user, params = { ids: [] }) => apiClient.get(user, `maccs-internships/internship-messages${makeQueryString(params)}`)
